module.exports = __webpack_public_path__ + "img/swiper4.931a6cfc.png";